import DOMPurify from 'dompurify';

const PURIFY_CONFIG: DOMPurify.Config = {
  USE_PROFILES: { html: true },
  ADD_TAGS: ['style'],
  ADD_ATTR: ['style', 'class', 'align', 'bgcolor', 'color', 'face', 'valign', 'border', 'cellpadding', 'cellspacing'],
};

/**
 * Sanitize email HTML for safe preview and canvas rendering.
 */
export function sanitizeEmailHtml(html: string): string {
  return DOMPurify.sanitize(html, PURIFY_CONFIG);
}
